import { Box, Divider, Fallback, HStack, VStack } from '@cbhq/cds-web/layout';

import {
  APPROVAL_RULE_ROW_GAP,
  APPROVER_COL_WIDTH,
  REQUIREMENT_COL_WIDTH,
  RULE_NAME_COL_WIDTH,
  SELECT_CONTROL_HEIGHT,
} from './ApprovalRuleRow';

const SKELETON_SECTIONS = [0, 1, 2] as const;
const SKELETON_ROWS = [0, 1, 2] as const;

function ApprovalRulesSkeletonRow() {
  return (
    <HStack alignItems="center" gap={APPROVAL_RULE_ROW_GAP} width="100%">
      <Box width={RULE_NAME_COL_WIDTH}>
        <Fallback width={140} height={18} />
      </Box>
      <Box width={APPROVER_COL_WIDTH}>
        <Fallback width={APPROVER_COL_WIDTH} height={SELECT_CONTROL_HEIGHT} />
      </Box>
      <Box width={REQUIREMENT_COL_WIDTH}>
        <Fallback width={REQUIREMENT_COL_WIDTH} height={SELECT_CONTROL_HEIGHT} />
      </Box>
      <HStack flexGrow={1} justifyContent="flex-end">
        <Fallback width={36} height={20} />
      </HStack>
    </HStack>
  );
}

function ApprovalRulesSkeletonSection() {
  return (
    <VStack gap={3} width="100%">
      <HStack alignItems="center" gap={APPROVAL_RULE_ROW_GAP} width="100%">
        <Box width={RULE_NAME_COL_WIDTH}>
          <Fallback width={160} height={24} />
        </Box>
        <Box width={APPROVER_COL_WIDTH}>
          <Fallback width={80} height={16} />
        </Box>
        <Box width={REQUIREMENT_COL_WIDTH}>
          <Fallback width={120} height={16} />
        </Box>
        <Box flexGrow={1} />
      </HStack>
      <VStack gap={3} width="100%">
        {SKELETON_ROWS.map((row) => (
          <ApprovalRulesSkeletonRow key={row} />
        ))}
      </VStack>
    </VStack>
  );
}

export function ApprovalRulesSkeleton() {
  return (
    <VStack gap={6} width="100%" testID="approval-rules-skeleton">
      {SKELETON_SECTIONS.map((section, index) => (
        <VStack key={section} gap={6} width="100%">
          <ApprovalRulesSkeletonSection />
          {index < SKELETON_SECTIONS.length - 1 ? <Divider /> : null}
        </VStack>
      ))}
    </VStack>
  );
}
